import { render, staticRenderFns } from "./EmployeeTeam.vue?vue&type=template&id=dfd00132&"
import script from "./EmployeeTeam.vue?vue&type=script&lang=js&"
export * from "./EmployeeTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports